import React from 'react';
import './Login.css';

function RightBanner() {
    return (
        <div className="v-auth-panel order-2 order-lg-1 w-lg-50 left-image">
            <div className="v-auth-panel__inner">
                <div className="v-auth-brand">
                    RESET
                    <span className="v-auth-brand__by">Powered by <b>VERTIVIO</b></span>
                </div>

                <h2 className="v-auth-panel__headline">
                    Understand behavior.<br />
                    <span className="v-auth-panel__grad">Create lasting change.</span>
                </h2>

                <p className="v-auth-panel__lead">
                    Reset pinpoints the psychological and social obstacles holding you
                    back &mdash; then trains you through them with guided, interactive practice.
                </p>

                <ul className="v-auth-benefits">
                    <li><span className="v-auth-check">&#10003;</span> Science-backed assessment that finds the real obstacle</li>
                    <li><span className="v-auth-check">&#10003;</span> Interactive training modules that build new habits</li>
                    <li><span className="v-auth-check">&#10003;</span> Progress tracking that shows what&rsquo;s working</li>
                </ul>

                <div className="v-auth-privacy">Secure. Confidential. HIPAA-aligned.</div>
            </div>
        </div>
    );
}

export default RightBanner;
